import { setStepVal } from '../../../../store/uploads/actions';
import { CheckIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { useDispatch } from 'react-redux';

const UploadStep = ({ variant, num, label }) => {
  const dispatch = useDispatch();

  let stepCircleClasses = "md:w-8 md:h-8 flex items-center justify-center rounded-full md:text-white font-medium";
  let stepLabelClasses = "text-sm font-medium";

  const handleStepChange = () => {
    if(variant === "completed" && num === 3)
      dispatch(setStepVal(num));
  }

  if (variant === "current") {
    stepCircleClasses += " md:bg-primary";
  } else if (variant === "completed") {
    stepCircleClasses += " bg-green-500";
  } else {
    stepCircleClasses += " bg-gray-400";
  }

  return (
    <div className="flex items-center gap-2">
      <div className={stepCircleClasses} onClick={handleStepChange}>
        {variant === "completed" ? <CheckIcon className="w-5 h-5" /> : num}<span className='md:hidden'>.</span>
      </div>
      <span className={stepLabelClasses}>{label}</span>
    </div>
  );
};


export default UploadStep;